import { render, staticRenderFns } from "./GameMetaDataView.vue?vue&type=template&id=73a7e112&scoped=true&"
import script from "./GameMetaDataView.vue?vue&type=script&lang=ts&"
export * from "./GameMetaDataView.vue?vue&type=script&lang=ts&"
import style0 from "./GameMetaDataView.vue?vue&type=style&index=0&id=73a7e112&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a7e112",
  null
  
)

export default component.exports